import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';
import { Localidad } from '../../domain/localidad.domain';

@Injectable({
  providedIn: 'root'
})
export class LocalidadService extends CommonService<Localidad> {
  constructor() {
    super('localidades');
  }
}
